export class AppUser {
    userName = '';
    password = '';
    culture = '';
cultureId = '';
StripeSessionId='';
company='';
accountName='';
}
